import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SpecialOrdersService } from '../../../../services/specialorders.service';
import { HelpersService } from '../../../../services/helpers.service';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateJobcardComponent } from '../../../modals/update-jobcard/update-jobcard.component';
import { NewJobcardService } from '../../../../services/new-jobcard.service';

@Component({
  selector: 'app-special-orders',
  templateUrl: './special-orders.component.html',
  styleUrls: ['./special-orders.component.scss'],
})
export class SpecialOrdersComponent implements OnInit {
  public loading: boolean = false;
  public orders: any = [];
  public outOfStockItems: any = [];
  public partnerID: string = '';
  public countryData: any = {};

  public columns: any = [
    {
      header: this.translate.instant('general.headers.job_card'),
      field: 'jobCardNo',
      type: 'jobcardno',
      width: '120px',
    },
    {
      header: this.translate.instant('bikeshop.modal.add_edit_user.technician'),
      field: 'technician',
      type: 'string',
      width: '150px',
    },
    {
      header: this.translate.instant('general.headers.cyclist'),
      field: 'customer',
      type: 'string',
      width: '180px',
    },
    {
      header: this.translate.instant('general.headers.phone'),
      field: 'phoneNumber',
      type: 'string',
      width: '150px',
    },
    {
      header: this.translate.instant('general.headers.description'),
      field: 'invoiceLineItemName',
      type: 'string',
      width: '200px',
    },
    {
      header: 'Qty', //this.translate.instant('general.headers.qty'),
      field: 'unitQuantity',
      type: 'string',
      width: '100px',
    },
    {
      header: 'Status',
      field: 'status',
      type: 'status',
      width: '150px',
    },
    {
      header: this.translate.instant('general.headers.so_date'),
      field: 'createdDate',
      type: 'date',
      width: '150px',
    },
  ];

  public outOfStockColumns: any = [
    {
      header: this.translate.instant('general.headers.job_card'),
      field: 'jobCardNo',
      type: 'jobcardno',
      width: '120px',
    },
    {
      header: this.translate.instant('bikeshop.modal.add_edit_user.technician'),
      field: 'technician',
      type: 'string',
      width: '150px',
    },
    {
      header: this.translate.instant('general.headers.cyclist'),
      field: 'customer',
      type: 'string',
      width: '180px',
    },
    {
      header: this.translate.instant('general.headers.phone'),
      field: 'phoneNumber',
      type: 'string',
      width: '150px',
    },
    {
      header: this.translate.instant('general.headers.description'),
      field: 'invoiceLineItemName',
      type: 'string',
      width: '200px',
    },
    {
      header: 'Qty', //this.translate.instant('general.headers.qty'),
      field: 'unitQuantity',
      type: 'string',
      width: '100px',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.date'),
      field: 'createdDate',
      type: 'date',
      width: '150px',
    },
  ];

  constructor(
    private helpersService: HelpersService,
    private translate: TranslateService,
    private ordersService: SpecialOrdersService,
    public modalService: NgbModal,
    public serviceRequest: ServiceRequestService,
    private newJobcardService: NewJobcardService,
  ) {
    this.getOrders();
  }

  ngOnInit() {
    this.partnerID = this.helpersService.getPartnerId();
    this.countryData = this.helpersService.getCountryData();
  }

  getOrders() {
    this.loading = true;
    this.ordersService
      .getSpecialOrdersV2(this.helpersService.getPartnerId())
      .subscribe((orders) => {
        this.orders = orders;
        this.refreshOrders();
      });
  }

  getOutOfStockItems() {
    this.loading = true;
    this.ordersService
      .getItemsOutOfStock(this.helpersService.getPartnerId())
      .subscribe(
        (items) => {
          this.outOfStockItems = items;
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  refreshOrders() {
    this.loading = true;
    this.ordersService
      .getSpecialOrdersV2(this.helpersService.getPartnerId(), true)
      .subscribe(
        (orders) => {
          this.orders = orders;
          this.loading = false;
          this.getOutOfStockItems();
        },
        (err) => {
          this.loading = false;
          this.getOutOfStockItems();
        },
      );
  }

  openJobCard(jobcardID) {

    if (this.helpersService.getPartnerData().UseNewJobCard) {
      this.newJobcardService.openManageJobCard(jobcardID, {
        onRefreshEvents: () => { 
          this.getOrders();
        }
      });

      return;
    }

    this.serviceRequest
      .getServiceRequestData(jobcardID)
      .subscribe((jobcard) => {
        const modalRef = this.modalService.open(UpdateJobcardComponent, {
          size: 'lg',
          backdrop: 'static',
          windowClass: 'jobcard-modal',
        });
        modalRef.componentInstance.jobcard = jobcard;
        modalRef.componentInstance.partnerID = this.partnerID;
        modalRef.result.then(
          (result) => {
            this.getOrders();
          },
          (onrejected) => {
            this.getOrders();
            //this.getDashboardData();
            //this.loadData(this.activeItem.index);
          },
        );
      });
  }

  isReady(status) {
    if (
      status.toLowerCase().indexOf('ready') > -1 ||
      status.toLowerCase().indexOf('ready') > -1
    ) {
      return true;
    } else {
      return false;
    }
  }

  isOrdered(status) {
    if (status.toLowerCase() === 'ordered') {
      return true;
    } else {
      return false;
    }
  }

  isNotOrdered(status) {
    if (status.toLowerCase() === 'not ordered') {
      return true;
    } else {
      return false;
    }
  }
}
